<script lang="js" setup>
import UiButton from "@/components/ui/UiButton.vue";
import UiButtonSecondary from "@/components/ui/UiButtonSecondary.vue";
import SocialIcon from "@/components/ui/SocialIcon.vue";
import FooterLink from "@/components/ui/FooterLink.vue";
import FooterLinkGroup from "@/components/ui/FooterLinkGroup.vue";
import { BoltIcon, PhoneIcon } from '@heroicons/vue/24/solid';
</script>

<template>
  <div class="bg-primary-dark">
    <div
      class="container max-w-screen-xl 2xl:max-w-screen-2xl mx-auto py-8 sm:py-10 lg:py-12 w-full px-4 sm:px-6 lg:px-8"
    >
      <div
        class="flex flex-col lg:flex-row lg:justify-between gap-8 sm:gap-10 lg:gap-12 xl:gap-0"
      >
        <div class="flex flex-col gap-y-8 sm:gap-y-12 lg:gap-y-16 xl:gap-y-28">
          <router-link to="/">
            <img
              alt="Chat Polls Logo"
              class="h-10 sm:h-12 lg:h-14"
              src="@/assets/chat-polls-logo.png"
            />
          </router-link>
          <div class="flex flex-row gap-3 sm:gap-4 lg:gap-6 xl:gap-x-12">
            <UiButton>
              <div class="flex gap-x-2 items-center">
                <BoltIcon class="size-4 sm:size-5 lg:size-6" />
                <span class="text-base sm:text-lg lg:text-xl font-medium"
                  >Start Now</span
                >
              </div>
            </UiButton>
            <UiButtonSecondary>
              <div class="flex gap-x-2 items-center">
                <PhoneIcon class="size-4 sm:size-5 lg:size-6" />
                <span class="text-base sm:text-lg lg:text-xl font-medium"
                  >Contact Us</span
                >
              </div>
            </UiButtonSecondary>
          </div>
        </div>

        <!--  Links -->
        <div
          class="text-base sm:text-lg lg:text-xl text-white grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-12 xl:gap-16 lg:max-w-screen-sm lg:flex-1"
        >
          <FooterLinkGroup title="Menu">
            <FooterLink text="About Us" />
            <FooterLink text="Product" />
            <FooterLink text="Services" />
          </FooterLinkGroup>
          <FooterLinkGroup title="Pages">
            <FooterLink text="News" />
            <FooterLink text="Pricing" />
            <FooterLink text="Testimonials" />
            <FooterLink text="Software" />
          </FooterLinkGroup>
          <FooterLinkGroup title="Resources">
            <FooterLink text="Sponsorship" />
            <FooterLink text="Press Release" />
            <FooterLink text="Public Relation" />
          </FooterLinkGroup>
        </div>
      </div>

      <!--  divider -->
      <div
        class="border border-white w-full rounded-full mt-10 sm:mt-12 lg:mt-16 xl:mt-24 mb-3 sm:mb-4"
      />

      <div
        class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 sm:gap-0"
      >
        <span
          class="font-poppins text-base sm:text-lg lg:text-xl text-white text-center sm:text-left"
        >
          © 2025 Copyright Chat-Polls
        </span>
        <div
          class="flex gap-x-4 sm:gap-x-6 lg:gap-x-8 justify-center sm:justify-end"
        >
          <SocialIcon href="#">
            <svg
              fill="none"
              viewBox="0 0 32 31"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.5404 7.71307H17.7246C17.0221 7.71307 16.4526 8.28188 16.4526 8.98355V12.795H21.5404C21.685 12.7918 21.8222 12.859 21.9082 12.9753C21.9942 13.0915 22.0183 13.2422 21.9728 13.3794L21.0316 16.1745C20.9449 16.431 20.7049 16.6045 20.4338 16.6065H16.4526V26.1351C16.4526 26.4859 16.1679 26.7704 15.8167 26.7704H12.6369C12.2856 26.7704 12.0009 26.4859 12.0009 26.1351V16.6065H10.093C9.74176 16.6065 9.45703 16.3221 9.45703 15.9712V13.4303C9.45703 13.0794 9.74176 12.795 10.093 12.795H12.0009V8.98355C12.0009 6.17687 14.2787 3.90161 17.0886 3.90161H21.5404C21.8916 3.90161 22.1763 4.18602 22.1763 4.53685V7.07783C22.1763 7.42866 21.8916 7.71307 21.5404 7.71307Z"
                fill="currentColor"
              />
            </svg>
          </SocialIcon>
          <SocialIcon href="#">
            <svg
              fill="none"
              viewBox="0 0 32 31"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clip-rule="evenodd"
                d="M21.5243 3.90161H11.3489C7.83657 3.90161 4.98926 6.74569 4.98926 10.254V20.4179C4.98926 23.9263 7.83657 26.7704 11.3489 26.7704H21.5243C25.0367 26.7704 27.884 23.9263 27.884 20.4179V10.254C27.884 6.74569 25.0367 3.90161 21.5243 3.90161ZM25.6583 20.418C25.6513 22.6955 23.8046 24.5401 21.5245 24.5471H11.3491C9.06895 24.5401 7.22228 22.6955 7.2153 20.418V10.2541C7.22228 7.97656 9.06895 6.13199 11.3491 6.12501H21.5245C23.8046 6.13199 25.6513 7.97656 25.6583 10.2541V20.418ZM22.4785 10.5717C23.1809 10.5717 23.7504 10.0029 23.7504 9.30116C23.7504 8.59945 23.1809 8.0306 22.4785 8.0306C21.776 8.0306 21.2065 8.59945 21.2065 9.30116C21.2065 10.0029 21.776 10.5717 22.4785 10.5717ZM16.4368 9.61872C13.2757 9.61872 10.7131 12.1786 10.7131 15.3363C10.7131 18.494 13.2757 21.0538 16.4368 21.0538C19.5979 21.0538 22.1605 18.494 22.1605 15.3363C22.1639 13.8188 21.5619 12.3626 20.4878 11.2896C19.4137 10.2166 17.9558 9.61533 16.4368 9.61872ZM12.939 15.3361C12.939 17.2658 14.505 18.8302 16.4368 18.8302C18.3686 18.8302 19.9346 17.2658 19.9346 15.3361C19.9346 13.4064 18.3686 11.8421 16.4368 11.8421C14.505 11.8421 12.939 13.4064 12.939 15.3361Z"
                fill="currentColor"
                fill-rule="evenodd"
              />
            </svg>
          </SocialIcon>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
